import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import ChartWrapper from 'components/Apps/EnvironmentMonitor/ChartWrapper'
import ListWrapper from 'components/Apps/EnvironmentMonitor/ListView'
import { TideWhite } from 'helpers/customIcons'
import {
  fetchHistoricalData,
  fetchForecastData,
} from 'reducers/environmentMonitor/reducer'
import {
  CHART_TYPE_FORECAST,
  TYPE_TIDE,
  isBoundaryLineShow,
  CHART_TYPE_HISTORICAL,
} from 'helpers/environmentMonitor'
import messages from 'components/Apps/EnvironmentMonitor/translate'
import ChartStv from 'components/Apps/EnvironmentMonitor/Charts/ChartStv'
import ChartHistorical from 'components/Apps/EnvironmentMonitor/Charts/ChartHistorical'

class Tide extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chartType: CHART_TYPE_FORECAST,
      datasetIndex: 0,
    }
  }

  componentList = {
    [`${CHART_TYPE_FORECAST}`]: ChartStv,
    [`${CHART_TYPE_HISTORICAL}`]: ChartHistorical,
  }

  componentDidMount() {
    this.fetchChartData(this.props.activeSite, this.state.chartType)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.activeSite !== nextProps.activeSite ||
      this.state.chartType !== nextState.chartType
    ) {
      this.fetchChartData(nextProps.activeSite, nextState.chartType)

      return false
    }

    return true
  }

  fetchChartData = (activeSite, chartType) => {
    const { fetchForecastData, fetchHistoricalData } = this.props
    const payload = {
      site: activeSite,
      now: moment.utc().format('YYYY-MM-DD HH:00:00'),
      type: TYPE_TIDE,
    }

    if (chartType === CHART_TYPE_FORECAST) {
      payload.depth = 5
      fetchForecastData(payload)
    } else {
      fetchHistoricalData(payload)
    }
  }

  onChartTypeBtnClick = evt => {
    this.setState({
      chartType: evt.currentTarget.value,
      datasetIndex: 0,
      itemIndex: 0,
    })
  }

  render() {
    const {
      intl: { formatMessage },
      chartData,
    } = this.props
    const { chartType, datasetIndex } = this.state
    const lineLevels = isBoundaryLineShow(
      chartData.get('data').toJS(),
      chartType,
      5,
      val => val > 5,
    )
    const ChartView = this.componentList[chartType]

    return (
      <>
        <ChartWrapper
          loader={chartData.get('loader')}
          chartType={chartType}
          chartTypeChange={this.onChartTypeBtnClick}>
          <ChartView
            unit={formatMessage(messages.meters)}
            chartData={chartData}
            datasetIndex={datasetIndex}
            lineLevels={lineLevels}
          />
        </ChartWrapper>
        <ListWrapper
          unit={formatMessage(messages.meters)}
          icon={TideWhite}
          dataView={chartData.get('dataView')}
          chartType={chartType}
        />
      </>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    chartData: state.getIn(['environmentMonitor', 'chartData']),
  }),
  {
    fetchHistoricalData,
    fetchForecastData,
  },
)(injectIntl(Tide))
